import React from "react";

/**
 * The Genie mark.
 *
 * A wisp rising from a lamp, reduced to the two strokes that carry the idea:
 * a low crescent for the lamp and a single curl leaving it. No spout, no
 * handle, no face. At 16px a literal lamp collapses into a blob, and a
 * cartoon one would sit badly next to an MLS wordmark, so the mark is the
 * gesture rather than the object.
 *
 * Strokes use currentColor so the mark takes the colour of whatever it sits
 * in, and the spark is the one filled element, which keeps a focal point
 * when the whole thing is rendered small.
 */
const GenieMark = ({ size = 22, className = "", title }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    {/* The lamp, implied: one low crescent. A drawn lamp with a spout and a
        handle collapses into a blob below about 24px, and would sit badly
        beside an MLS wordmark besides. It also happens to read as a smile,
        which is the friendliest thing about the mark. */}
    <path
      d="M4.6 16.9c1.5 2 4.2 3.2 7.4 3.2s5.9-1.2 7.4-3.2"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    {/* The wisp leaving it. An open S rather than a coil: a spiral reads at
        200px and turns to mush at 16, which is the size that matters here. */}
    <path
      d="M12.1 16.5c-1.9-1.5-1.9-3.3-.2-4.4 1.6-1 1.8-2.4.5-3.4"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* The four-point sparkle is what every AI surface uses, so it is what
        people already read as AI. Two of them, unequal, because a pair reads
        as magic where one reads as decoration. */}
    <path
      d="M18.3 3.3l.85 2.3 2.3.85-2.3.85-.85 2.3-.85-2.3-2.3-.85 2.3-.85z"
      fill="currentColor"
    />
    {/* The smaller one is the first thing to turn to mush when the mark gets
        small, so below the nav rail's size it simply is not drawn. */}
    {size >= 20 ? (
      <path
        d="M6.6 6.4l.5 1.35 1.35.5-1.35.5-.5 1.35-.5-1.35-1.35-.5 1.35-.5z"
        fill="currentColor"
      />
    ) : null}
  </svg>
);

export default GenieMark;
